module.exports = __webpack_public_path__ + "static/scale-model-of-national-center-for-children-in-abilene-texas-ca7386dbccb1e1c722bae8fbd92f42ee.png";